import { render, staticRenderFns } from "./CertificateGuidePop.vue?vue&type=template&id=ed78a824"
import script from "./CertificateGuidePop.vue?vue&type=script&lang=js"
export * from "./CertificateGuidePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed78a824')) {
      api.createRecord('ed78a824', component.options)
    } else {
      api.reload('ed78a824', component.options)
    }
    module.hot.accept("./CertificateGuidePop.vue?vue&type=template&id=ed78a824", function () {
      api.rerender('ed78a824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/CertificateGuidePop.vue"
export default component.exports